<script lang="ts">
	import type { RestaurantDynamic, RestaurantSemiStatic } from "$lib/def/landing";
	import type { RestaurantExposed } from "$lib/serv/restaurant";
	import type { Item, Menu } from "proto/menu";

	import { Vertical } from "$lib/def/verticals";
	import { checkForModifierPrice } from "$lib/serv/food-cart";
	import { findRealItem, retypeItem } from "$lib/ui/home/food/menu/Restaurant.svelte";
	import { formatCurrency } from "$lib/util/format";

	import ItemTile from "$lib/ui/home/shop/ItemTile.svelte";
	import Carousel from "$lib/ui/layout/Carousel.svelte";
	import LazyBackgroundImage from "$lib/ui/shared/LazyBackgroundImage.svelte";

	export let loading: boolean | undefined;
	export let menu: Menu | undefined;
	export let restaurant: Partial<RestaurantExposed & RestaurantSemiStatic & RestaurantDynamic>;
	export let getItemLink: (item: any) => string; 

	function findItems(menu: Menu, ids: number[]) {
		if (!ids) return []; // FEW-964 - breaking menus with bad 'featured' data
		return ids.map(id => {
			const section = menu.sections.find(s => s.items.some(i => i.id === id));
			const item = section?.items.find(i => i.id === id);
			if (!item) return;
			return { ...item, section_id: section?.id };
		}).filter(Boolean) as (Item & {section_id:number})[];
	}
</script>

{#if loading}
	<Carousel cache={{loading: true}} type="aisle">
		<div slot="title"></div>
	</Carousel>
{:else if menu?.featured_items?.length}
	<div class="highlights">
		{#each menu.featured_items as feature}
			<Carousel cache={{payload: {menu,feature}}} type="aisle" key={({menu:m,feature:f}) => findItems(m, f.items)} let:item>
				{@const priced = checkForModifierPrice(item, menu.options, menu.extras, menu.addons)}
				{@const realItem = findRealItem(item, menu) ?? retypeItem(item)}
				{@const href = getItemLink(realItem)}
				<h3 slot="title" class="headline-m bold">Highlights</h3>
				{#if restaurant.vertical === Vertical.Store}
					<a class="item swimlane-menu-item" {href} rel="nofollow" data-sveltekit-noscroll>
						<ItemTile {item} />
					</a>
				{:else}
					<a class="item" {href} rel="nofollow" data-sveltekit-noscroll>
						<LazyBackgroundImage image={[item.media, 200]} alt={item.name} />
						<div class="label-xl bold m-0">
							{item.name}
							{#if item.collect_only}
								<span class="pill small label-s bold m-0">Collect only</span>
							{/if}
						</div>
						<div class="label-xl medium red m-0">{priced.showFrom ? 'From' : ''} {formatCurrency(priced.price)}</div>
					</a>
				{/if}
			</Carousel>
		{/each}
	</div>
{/if}

<style lang="scss">
	.highlights {
		padding: 32px 0;
	}
</style>